import { useEffect } from 'react'

import { Alert } from '@vtex/shoreline'
import { t } from 'i18next'

import { Button } from '~/components/Buttons'
import Panel from '~/components/Panel'
import { FormGroup } from '~/components/unform'
import Form from '~/components/unform/Form'

import { IdentificationFields } from './elements/IdentificationFields'
import { ImageFields } from './elements/ImageFields'
import { TypeFields } from './elements/TypeFields'
import { VideoFields } from './elements/VideoFields'
import { useAdSizeForm } from './hook/useAdSizeForm'

const AdSizeForm = () => {
  const {
    formData,
    formRef,
    handleChangeType,
    handleSuggestedSizes,
    handleChangeSizes,
    initialData,
    handleChangeName,
    handleSubmit,
    showIdsFields,
    readyToSubmit,
    sizeExists,
    isPending
  } = useAdSizeForm()

  useEffect(() => {
    formRef?.current?.setData(initialData)
  }, [formRef, initialData])

  return (
    <div className="col">
      <Panel title={t('rm:adsize.form.title')}>
        <Form
          ref={formRef}
          onSubmit={handleSubmit}
          className="d-flex flex-wrap gap-3"
          initialData={initialData}
        >
          <TypeFields onChange={handleChangeType} />

          {formData.type && (
            <>
              {formData.type === 'video' && (
                <VideoFields onChange={handleSuggestedSizes} />
              )}

              {(formData.type === 'image' ||
                formData.type === 'digital_signage' ||
                formData.type === 'sponsored_brand_image' ||
                formData.type === 'sponsored_brand_video') && (
                <ImageFields onChange={handleChangeSizes} />
              )}

              {showIdsFields && (
                <IdentificationFields onChange={handleChangeName} />
              )}

              {sizeExists && (
                <Alert variant="warning">
                  {t('rm:adsize.form.alerts.sizeExists')}
                </Alert>
              )}

              {readyToSubmit && (
                <FormGroup className="w-100">
                  <Button
                    type="submit"
                    text={t('common:actions.save')}
                    template="primary"
                    loading={isPending}
                    disabled={isPending}
                    textLoading={`${t('common:actions.saving')}...`}
                  />
                </FormGroup>
              )}
            </>
          )}
        </Form>
      </Panel>
    </div>
  )
}

export default AdSizeForm
